<template>
  <a-dialog v-model="show" width="800px" max-width="80vw" persistent scrollable>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span> {{ $t("agenda.lblAttributeInfo") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="color: black">
        <p class="mb-0">
          <span class="subtitle-2 font-weight-bold">{{ $t("Meeting") }}:</span>
          {{ meetingObject.meetingName }}
        </p>
        <p class="mb-0">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblCompanyName") }}:</span
          >
          {{ tenantName }}
        </p>
        <p class="mb-0">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("admin.lblMeetingType") }}:</span
          >
          {{ meetingObject.meetingType }}
        </p>
        <p class="mb-0" v-if="meetingObject.meetingTheme">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblMeetingTheme") }}:</span
          >
          {{ meetingObject.meetingTheme }}
        </p>
        <p class="subtitle-2 font-weight-bold mb-1 mt-1">
          {{ $t("agenda.lblAttendee") }}:
        </p>
        <ul class="ml-2">
          <li
            class="mb-0"
            v-for="attendee in attendeesComputedList"
            :key="`attendee-list-${attendee.id}-${attendee.email}`"
          >
            {{
              attendee.firstName && attendee.firstName !== ""
                ? `${attendee.firstName} ${attendee.lastName}`
                : attendee.email
            }}
            <span v-if="attendee.attendedState >= 0">{{
              attendee.attendedState === 0
                ? `[${$t("agenda.lblInPerson")}]`
                : attendee.attendedState === 1
                ? `[${$t("agenda.lblRemote")}]`
                : attendee.attendedState === 2
                ? `[${$t("agenda.Absent")}]`
                : ""
            }}</span>
            <span
              class="ml-1 note-text"
              v-if="attendee.attendeNote && attendee.attendeNote !== ''"
            >
              [{{$t("agenda.lblNote")}}: {{ attendee.attendeNote }}]
            </span>
          </li>
        </ul>

        <div class="mt-2">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblMeetingDescription") }}:</span
          >
          <p
            class="mt-0 mb-0"
            v-html="$sanitizeHtml(meetingObject.description)"
          ></p>
        </div>
        <p class="mb-0">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblMeetingScheduledDate") }}:</span
          >
          {{ start_date }} - {{ end_date }}
        </p>
        <p class="mb-0">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblMeetingActualTime") }}:</span
          >
          {{ actual_start_date }} - {{ actual_end_date }}
        </p>
        <p class="mb-0">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblMeetingLocation") }}:</span
          >
          {{ meetingObject.location }}
        </p>
        <p class="mb-2">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblResType") }}:</span
          >
          {{ resolutionType }}
        </p>
        <v-divider></v-divider>
        <div class="mt-2 mb-2" v-if="votingResult && votingResult.length > 0">
          <span class="subtitle-2 font-weight-bold"
            >{{ $t("agenda.lblMeetingPurpose") }}:</span
          >
        </div>

        <div class="mt-2 mb-2 ml-2">
          <ul
            style="list-style: square; margin-left: 0; font-size: 11pt"
            class="mt-2"
            v-for="category in votingResult"
            :key="`mp-cat-${category.id}`"
          >
            <li>
              <span class="text-subtitle-2 font-weight-bold">{{
                category.name
              }}</span>
              <ul
                style="list-style: disc"
                v-for="(topic, increment) in category.topics"
                :key="`mp-cat-topic-${topic.id}-${increment}`"
              >
                <li>
                  <span class="text-body-2 font-weight-medium">{{
                    topic.agenda.agendaName
                  }}</span>
                  <ul>
                    <li
                      :style="
                        agendanumbering == '' ||
                        agendanumbering == 'no_numbering'
                          ? 'list-style: circle'
                          : 'list-style-type: none'
                      "
                    >
                      <span v-if="agendanumbering == 'numbering_for_meeting'"
                        >{{ topic.meetindNumbering }}.
                      </span>
                      <span
                        v-else-if="agendanumbering == 'numbering_for_category'"
                        >{{ increment + 1 }}.
                      </span>
                      <span class="text-body-2 font-weight-medium">{{
                        topic.topicName
                      }}</span>
                      <ul
                        v-if="
                          topic.voting_result && topic.voting_result.length > 0
                        "
                        style="list-style: circle"
                      >
                        <span class="text-body-2 font-weight-medium"
                          >{{ $t("agenda.lblVotingResult") }}:</span
                        >
                        <template v-for="result in topic.voting_result">
                          <ul
                            style="list-style: circle"
                            v-if="result.approvalStatus"
                            :key="`vt-result-${result.firstName}-${result.topicId}-${result.approvalStatus}`"
                          >
                            <li v-if="result.approvalStatus" class="">
                              <p class="mb-0">
                                <span class="text-body-2 font-weight-medium">
                                  {{
                                    result.firstName
                                      ? `${result.firstName} ${result.lastName}:`
                                      : ""
                                  }}
                                </span>
                                {{
                                  result.approvalStatus == "approve"
                                    ? $t("agenda.btnApproval")
                                    : result.approvalStatus == "reject"
                                    ? $t("agenda.btnReject")
                                    : result.approvalStatus == "abstain"
                                    ? $t("agenda.btnAbstain")
                                    : ""
                                }}
                              </p>
                              <span
                                v-if="result.votingComment"
                                class="subtitle-2"
                                >{{ $t("agenda.lblComment") }}: </span
                              ><span
                                v-if="result.votingComment"
                                v-html="result.votingComment"
                              ></span>
                            </li>
                          </ul>
                        </template>
                      </ul>
                      <ul
                        v-if="
                          meetingObject.resolutionType.toLowerCase() ===
                            'in writing' &&
                          topic.consent_status &&
                          topic.consent_status.length > 0
                        "
                        style="list-style: circle"
                        class="mt-2"
                      >
                        <span class="text-body-2 font-weight-medium"
                          >{{ $t("agenda.lblAuditorsConsentResult") }}:</span
                        >
                        <template v-for="result in topic.consent_status">
                          <ul
                            style="list-style: circle"
                            v-if="
                              result.consentStatus &&
                              result.consentStatus !== null
                            "
                            :key="`v-consent-status-${result.topicId}-${result.approvalStatus}`"
                          >
                            <li>
                              <p class="mb-0">
                                <span class="text-body-2 font-weight-medium">
                                  {{
                                    result.firstName
                                      ? `${result.firstName} ${result.lastName}:`
                                      : ""
                                  }}
                                </span>
                                {{
                                  result.consentStatus == "hasObjection"
                                    ? $t("agenda.btnHasObjection")
                                    : result.consentStatus == "noObjection"
                                    ? $t("agenda.btnNoObjection")
                                    : ""
                                }}
                              </p>
                              <span
                                v-if="result.consentComment"
                                class="subtitle-2"
                                >{{ $t("agenda.lblComment") }}: </span
                              ><span
                                v-if="result.consentComment"
                                v-html="result.consentComment"
                              ></span>
                            </li>
                          </ul>
                        </template>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              color="secondary"
              small
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnCancel") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnCancel") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { formatDate } from "../utils/util";
export default {
  name: "GenerateAttribute",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    categorizedTopics: {
      type: Array,
      default: () => [],
    },
    meetingObject: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
    let element = document.getElementById("rte_editor_imgResize");
    if (element) {
      element.remove();
    }
  },
  computed: {
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
      resolutionTypesList: "meeting/getResolutionTypesList",
    }),
    ...mapState({
      userList: (state) => state.people.userList,
      meetingVoterSummary: (state) => state.meeting.meetingVoterSummary,
    }),
    selectedLang() {
      return this.$i18n.locale;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd/MM/yyyy" : "yyyy/MM/dd";
    },
    displayDateFormat() {
      return this.selectedLang !== "ja"
        ? "dd/MM/yyyy hh:mm aaa"
        : "yyyy/MM/dd HH:mm";
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    getCurrentTenant() {
      return this.$auth.user.companyTitles.find(
        (u) => u.id === this.selectedTenant
      );
    },
    getTenantByDate() {
      if (!this.getCurrentTenant) return null;

      const rawStart = this.meetingObject?.scheduletStartTimeInUTC || this.meetingObject?.scheduledStartTimeInUTC;
      if (!rawStart) return null;
      const targetTime = new Date(rawStart).getTime();
      if (isNaN(targetTime)) return null;

      const historyRaw = Array.isArray(this.getCurrentTenant.tenantNamesHistory)
        ? this.getCurrentTenant.tenantNamesHistory
        : [];
      if (!historyRaw.length) return null;

      const sorted = historyRaw
        .map(h => ({ ...h, _time: new Date(h.updated_at).getTime() }))
        .filter(h => !isNaN(h._time))
        .sort((a,b) => a._time - b._time);
      if (!sorted.length) return null;

      const len = sorted.length;

      // Single entry: only return on exact match
      if (len === 1) {
        return sorted[0]._time === targetTime ? sorted[0] : null;
      }

      const first = sorted[0];
      const last = sorted[len - 1];

      // Exact boundary checks
      if (targetTime === first._time) return first;
      if (targetTime === last._time) return last;

      // Outside range checks
      if (targetTime > last._time) return null; // after all -> null (requirement)
      if (targetTime < first._time) return first; // earlier than first -> first (existing multi-entry behavior)

      // Mid-list exact match (we already checked first & last)
      const exact = sorted.find(e => e._time === targetTime);
      if (exact) return exact;

      // Interval search: pick the next (later) entry when between two
      for (let i = 0; i < len - 1; i++) {
        const cur = sorted[i];
        const nxt = sorted[i + 1];
        if (cur._time < targetTime && targetTime < nxt._time) return nxt;
      }

      return null; // Fallback
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      if (this.getTenantByDate) {
        // Prefer old_name if present, else name
        return this.getTenantByDate.name || "";
      }
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    start_date() {
      return formatDate(
        new Date(this.meetingObject.scheduletStartTimeInUTC),
        this.displayDateFormat
      );
    },
    end_date() {
      return formatDate(
        new Date(this.meetingObject.scheduledEndTimeInUTC),
        this.displayDateFormat
      );
    },
    actual_start_date() {
      return this.meetingObject.startMeetingTime
        ? formatDate(
            new Date(this.meetingObject.startMeetingTime),
            this.displayDateFormat
          )
        : "";
    },
    actual_end_date() {
      return this.meetingObject.endMeetingTime
        ? formatDate(
            new Date(this.meetingObject.endMeetingTime),
            this.displayDateFormat
          )
        : "";
    },
    resolutionType() {
      const resolution = this.resolutionTypesList.find(
        (item) => this.meetingObject.resolutionType == item.value
      );
      return resolution ? resolution.label : "";
    },
    agendanumbering() {
      return this.tenantSettingTypes("agendanumbering");
    },
    votingResult() {
      const catList = this.categorizedTopics.filter(
        (cat) => cat.topics.length > 0
      );
      catList.forEach(async (category) => {
        category.topics.forEach(async (item) => {
          const topicVotingData = this.meetingVoterSummary.find((vote) => {
            return vote.Id === item.Id;
          });
          if (topicVotingData) {
            const resultData = topicVotingData.voting_data;
            const result = resultData.map((item) => {
              let person = this.meetingObject.attendees.find(
                (f) => f.email === item.userEmail
              );
              if (!person) {
                person = this.userList.find((u) =>
                  u.contactEmailIds.includes(item.userEmail)
                );
              }
              return {
                ...item,
                profilePhoto: person ? person.profilePhoto : null,
                firstName: person ? person.firstName : "",
                lastName: person ? person.lastName : "",
              };
            });
            item.voting_result =
              result.length > 0
                ? result.filter(
                    (item) =>
                      item.approvalStatus && item.approvalStatus !== null
                  )
                : [];
            item.consent_status =
              result.length > 0
                ? result.filter(
                    (item) => item.consentStatus && item.consentStatus !== null
                  )
                : [];
          }
        });
      });
      return catList;
    },
    attendeesComputedList() {
      const _this = this;
      const attendees = [];
      this.meetingObject.attendees.forEach((item, index) => {
        const uData = this.userList.find((u) => u.id == item.id);
        if (uData) {
          item.profilePhoto = uData.profilePhoto;
          item.title = uData.title ?? "";
          item.firstName = uData.firstName ?? "";
          item.lastName = uData.lastName ?? "";
        }
        if (_this.selectedState && _this.selectedState != null) {
          item.attendedState = _this.selectedState;
        }
        item.order = item.order || index + 1;
        item.emailList = [];
        const isExistIndex = attendees.findIndex((u) => u.id == item.id);
        if (isExistIndex === -1) {
          attendees.push(item);
        } else {
          if (
            attendees[isExistIndex].emailList &&
            !attendees[isExistIndex].emailList.includes(item.email)
          ) {
            attendees[isExistIndex].emailList.push(item.email);
          } else {
            attendees[isExistIndex].emailList = [item.email];
          }
        }
      });
      return attendees;
    },
  },
  methods: {
    ...mapActions({
      getMeetingTopicVote: "meeting/getMeetingTopicVote",
    }),
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.error-element {
  color: var(--v-error-base) !important;
}
.note-text {
  white-space: pre-line;
}
</style>